import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
	  etablissement: {},
	},
	getters: {
		etablissement: state => state.etablissement
	},
    mutations: {
		setEtablissement(state, etablissement) {
			state.etablissement = etablissement
		}
    }
});

export default store;
